import { finAppStatusConstants } from '../constants/actionTypes'

let initialState = { status: '', url: '', isFetching: false }

export const finAppStatus = (
  state = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case finAppStatusConstants.FETCH_FINAPPSTATUS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case finAppStatusConstants.FETCH_FINAPPSTATUS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      }

    default:
      return state
  }
}
